import { getAttrMarkup, IBuildTaskDef, register } from '@wm/transpiler';
import { IDGenerator } from '@wm/core';

const tagName = 'div';
const idGen = new IDGenerator('wm_lottie');

register('wm-lottie', (): IBuildTaskDef => {
    return {
        pre: (attrs) => {
          const counter = idGen.nextUid();
          return `<${tagName} wmLottie #${counter}="wmLottie" ${getAttrMarkup(attrs)}>`;
        },
        post: () => `</${tagName}>`
    };
});

export default () => {};
